import {
  WSCard,
  WSElement,
  WSSectionToolbar,
  WSTimeline,
  WSTimelineItemProps
} from "@wingspanhq/fe-component-library";
import React from "react";

// Placeholder timeline data — replace with API-backed payroll history once available.
const PLACEHOLDER_HISTORY: WSTimelineItemProps[] = [
  {
    content: "Payroll finalized",
    date: new Date("2026-01-15"),
    pills: [{ text: "Completed", theme: "success" }]
  },
  {
    content: "Payroll submitted for review",
    date: new Date("2026-01-12"),
    pills: [{ text: "Pending", theme: "neutral" }]
  }
];

type Props = {
  onViewAll?: () => void;
};

export const RecentHistoryWidget: React.FC<Props> = ({ onViewAll }) => (
  <WSElement>
    <WSSectionToolbar
      button={{ label: "View all", onClick: onViewAll }}
      title="Recent history"
    />
    <WSCard mt="M">
      <WSTimeline items={PLACEHOLDER_HISTORY} />
    </WSCard>
  </WSElement>
);
